import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, PhoneIcon, InstagramIcon, MessageCircleIcon } from 'lucide-react';
export const ContactSection: React.FC = () => {
  return <section className="section section-dark relative py-20 overflow-hidden" id="contact" data-id="element-283">
      {/* Background Effects */}
      <div className="absolute -top-20 left-1/4 w-96 h-96 bg-green-500/5 rounded-full filter blur-3xl" data-id="element-284"></div>
      <div className="absolute -bottom-20 right-1/4 w-96 h-96 bg-green-500/5 rounded-full filter blur-3xl" data-id="element-285"></div>

      <div className="container mx-auto px-4 section-content relative z-10" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto text-center" data-id="element-287">
          {/* Header */}
          <h2 className="text-4xl md:text-6xl font-black mb-4" data-id="element-288">
            MÁŠ NĚJAKÉ <span className="text-green-500" data-id="element-289">OTÁZKY</span>? NAPIŠ MI!
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-green-500/50 via-green-500 to-green-500/50 mx-auto rounded-full mb-8" data-id="element-290"></div>

          {/* Main Message */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} viewport={{
          once: true
        }} className="mb-12" data-id="element-291">
            <p className="text-xl md:text-2xl text-gray-300 mb-6 leading-relaxed" data-id="element-292">
              Máš otázky ohledně{' '}
              <span className="text-green-400 font-semibold" data-id="element-293">
                tréninkových plánů
              </span>
              ,
              <span className="text-green-400 font-semibold" data-id="element-294">
                {' '}
                zelených superpotravin
              </span>{' '}
              nebo
              <span className="text-green-400 font-semibold" data-id="element-295">
                {' '}
                podnikání s Green Ways
              </span>
              ?
            </p>
            <p className="text-lg md:text-xl text-gray-400" data-id="element-296">
              Neváhej mě kontaktovat. Rád ti pomůžu najít řešení, které bude
              nejlépe vyhovovat tvým potřebám.
            </p>
          </motion.div>

          {/* Contact Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-297">
            {/* Email Card */}
            <motion.a href="mailto:ondrej.janik@body-hack.cz" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} viewport={{
            once: true
          }} whileHover={{
            y: -5,
            boxShadow: '0 20px 40px -5px rgba(34, 197, 94, 0.4)'
          }} className="bg-gradient-to-br from-gray-900 to-gray-800 p-8 rounded-xl border border-green-500/30 luxury-card transition-all duration-300 hover:border-green-500/50 group" data-id="element-298">
              <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-500/30 transition-colors duration-300" data-id="element-299">
                <MailIcon className="w-8 h-8 text-green-500" data-id="element-300" />
              </div>
              <h3 className="text-lg font-bold mb-2" data-id="element-301">Email</h3>
              <p className="text-green-400 text-sm break-all" data-id="element-302">
                ondrej.janik@body-hack.cz
              </p>
            </motion.a>

            {/* Phone Card */}
            <motion.a href="tel:+420608721052" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} viewport={{
            once: true
          }} whileHover={{
            y: -5,
            boxShadow: '0 20px 40px -5px rgba(34, 197, 94, 0.4)'
          }} className="bg-gradient-to-br from-gray-900 to-gray-800 p-8 rounded-xl border border-green-500/30 luxury-card transition-all duration-300 hover:border-green-500/50 group" data-id="element-303">
              <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-500/30 transition-colors duration-300" data-id="element-304">
                <PhoneIcon className="w-8 h-8 text-green-500" data-id="element-305" />
              </div>
              <h3 className="text-lg font-bold mb-2" data-id="element-306">Telefon</h3>
              <p className="text-green-400 text-sm" data-id="element-307">+420 608 721 052</p>
            </motion.a>

            {/* Instagram Card */}
            <motion.a href="https://www.instagram.com/ondra.janikk/" target="_blank" rel="noopener noreferrer" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} viewport={{
            once: true
          }} whileHover={{
            y: -5,
            boxShadow: '0 20px 40px -5px rgba(34, 197, 94, 0.4)'
          }} className="bg-gradient-to-br from-gray-900 to-gray-800 p-8 rounded-xl border border-green-500/30 luxury-card transition-all duration-300 hover:border-green-500/50 group" data-id="element-308">
              <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-500/30 transition-colors duration-300" data-id="element-309">
                <InstagramIcon className="w-8 h-8 text-green-500" data-id="element-310" />
              </div>
              <h3 className="text-lg font-bold mb-2" data-id="element-311">Instagram</h3>
              <p className="text-green-400 text-sm" data-id="element-312">@ondra.janikk</p>
            </motion.a>
          </div>

          {/* Call to Action */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-xl p-8 md:p-10 border border-green-500/30 luxury-card relative overflow-hidden" data-id="element-313">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-500 to-transparent" data-id="element-314"></div>
            <div className="absolute -right-20 -top-20 w-64 h-64 bg-green-500/5 rounded-full filter blur-3xl" data-id="element-315"></div>
            <div className="absolute -left-20 -bottom-20 w-64 h-64 bg-green-500/5 rounded-full filter blur-3xl" data-id="element-316"></div>
            <div className="relative z-10" data-id="element-317">
              <MessageCircleIcon className="w-12 h-12 text-green-500 mx-auto mb-4" data-id="element-318" />
              <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-319">
                Připraven na <span className="text-green-500" data-id="element-320">změnu</span>?
              </h3>
              <p className="text-gray-300 text-lg mb-6 max-w-2xl mx-auto" data-id="element-321">
                Neváhej a kontaktuj mě ještě dnes. Společně najdeme cestu k tvým
                cílům.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-322">
                <a href="mailto:ondrej.janik@body-hack.cz" className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-green-500/50" data-id="element-323">
                  Napsat email
                </a>
                <a href="https://www.instagram.com/ondra.janikk/" target="_blank" rel="noopener noreferrer" className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-3 px-8 rounded-lg transition-all duration-300 hover:scale-105 border border-green-500/30 hover:border-green-500/50" data-id="element-324">
                  Instagram DM
                </a>
              </div>
            </div>
          </motion.div>

          {/* Closing Message */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} viewport={{
          once: true
        }} className="mt-12 pt-8 border-t border-gray-800" data-id="element-325">
            <p className="text-gray-400 text-sm md:text-base" data-id="element-326">
              Děkuji, že jsi navštívil{' '}
              <span className="text-green-400 font-semibold" data-id="element-327">BODY-HACK.CZ</span>
            </p>
            <p className="text-gray-500 text-xs md:text-sm mt-2" data-id="element-328">
              Tvá cesta ke zdravému tělu a mysli začíná právě teď
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};